const GET_JWT_TOKEN = `/click-business/auth`;

// Shops
const GET_SERVICES = '/services';
const GET_SERVICE = (id: string) => `/services/${id}`;
const CREATE_SERVICE = `/services`;
const UPDATE_SHOP = (id: string) => `/services/${id}`;
const DELETE_SHOP = (id: string) => `/services/${id}/delete`;
const UPDATE_SERVICE_ADDRESS = (id: string) => `/services/${id}/update-address`;
const UPDATE_SERVICE_CHANNEL = (id: string) => `/services/${id}/update-channel`;

export {
  GET_JWT_TOKEN,
  GET_SERVICE,
  GET_SERVICES,
  CREATE_SERVICE,
  UPDATE_SHOP,
  DELETE_SHOP,
  UPDATE_SERVICE_ADDRESS,
  UPDATE_SERVICE_CHANNEL,
};
